module.exports = __webpack_public_path__ + "img/92127.f6018c38.svg";